import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo_mpp_on_red_bg.png'


const _hoisted_1 = {
  class: "position-absolute text-white pt-3 pb-3 ps-3 pe-3",
  id: "contact-form"
}
const _hoisted_2 = { class: "fs-6" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "mt-4 fs-6 mb-0" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div id=\"contact\" class=\"pt-4 container-fluid\"><div class=\"row justify-content-center\"><div class=\"col-4 text-center mt-3 fs-5\"><img alt=\"Marlyse Photo\" class=\"mt-5\" src=\"" + _imports_0 + "\"><div class=\"text-white mt-5\"> Marlyse KNOP </div><div class=\"text-white\"> 50, Rue de la Tourelle </div><div class=\"text-white\"> 92100 Boulogne Billancourt </div><div class=\"text-white\"> + 33 (0)6 85 73 52 59 </div><div class=\"text-white\"> www.photos-presse.com </div><div class=\"text-white\"> contact@marlysephoto.com </div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _withDirectives(_createElementVNode("input", {
          id: "contact-email",
          class: "p-2 w-100",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          type: "email",
          placeholder: _ctx.placeHolderEmail
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.labelMessage), 1),
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control rounded-0",
          id: "contact-message",
          rows: "6",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event))
        }, null, 512), [
          [_vModelText, _ctx.message]
        ]),
        _createElementVNode("button", {
          class: "text-white btn btn-danger border-0 rounded-1 pt-1 pb-1 ps-5 pe-5 mt-2",
          type: "submit",
          id: "contact-button-send",
          disabled: (!_ctx.email || !_ctx.REGEX_EMAIL.test(_ctx.email)) || !_ctx.message || _ctx.isMessageSending,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickedSend && _ctx.clickedSend(...args)))
        }, _toDisplayString(_ctx.buttonSend), 9, _hoisted_5)
      ])
    ])
  ]))
}